var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Bugsnag from '@bugsnag/js';
var PURCHASE_ERROR_CONTEXT = 'User-checkout';
var PurchaseError = /** @class */ (function (_super) {
    __extends(PurchaseError, _super);
    /**
     * Basic constructor (always include a purchase and context).
     * @param message
     * @param context
     * @param purchase
     * @param paymentMethod
     * @param innerError
     */
    function PurchaseError(message, purchase, paymentMethod, innerError, displayMessage) {
        if (paymentMethod === void 0) { paymentMethod = null; }
        if (innerError === void 0) { innerError = null; }
        if (displayMessage === void 0) { displayMessage = null; }
        var _this = _super.call(this, message) || this;
        // https://github.com/microsoft/TypeScript-wiki/blob/81fe7b91664de43c02ea209492ec1cea7f3661d0/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, PurchaseError.prototype);
        _this.name = 'PurchaseError';
        _this.purchase = purchase;
        _this.paymentMethod = paymentMethod;
        _this.innerError = innerError;
        _this.displayMessage = displayMessage;
        return _this;
    }
    PurchaseError.prototype.notifyBugsnag = function () {
        var _a;
        var metaData = {
            "purchase": this.purchase
        };
        if (this.innerError) {
            metaData = Object.assign(metaData, { "Error-Message": (_a = this.innerError.message) !== null && _a !== void 0 ? _a : '' });
        }
        if (this.paymentMethod) {
            metaData = Object.assign(metaData, { "Payment-method": this.paymentMethod });
        }
        Bugsnag.notify(this, function (event) {
            event.addMetadata("Additional Info", metaData);
            event.context = PURCHASE_ERROR_CONTEXT;
        });
    };
    PurchaseError.prototype.getDisplayMessage = function () {
        if (this.displayMessage) {
            return this.displayMessage;
        }
        return this.message;
    };
    return PurchaseError;
}(Error));
export { PurchaseError };
